export default __webpack_public_path__ + "static/media/03.c31052c0.png";